import { useSelector, useDispatch } from "react-redux";

import i18n from '../../i18n/i18n'
import { setLanguage } from '../../redux/features/localizationSlice'

import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Tooltip from "@mui/material/Tooltip";

import LanguageIcon from '@mui/icons-material/Language';

const LanguageSwitcher = ({color}) =>{
    const { t, changeLanguage } = i18n;

    const language = useSelector((state) => state.localization.language);
    const dispatch = useDispatch();

    return(
        <Box sx={{display:'flex', alignItems:'center'}}>
            <Tooltip title={t("tooltips.changeLanguage")}>
                <Button 
                    variant="contained"
                    endIcon={<LanguageIcon />}
                    onClick={() => {
                        changeLanguage(language === 'fr' ? 'en' : 'fr');
                        dispatch(setLanguage(language === 'fr' ? 'en' : 'fr'));
                        window.scrollTo(0, 0);
                        window.location.reload();
                    }}
                >
                    {(language === 'fr' ? 'en' : 'fr')}
                </Button>
            </Tooltip>
        </Box>
    );
}

export default LanguageSwitcher;